export const NOT_STARTED = 'NOT_STARTED';

export const LOADING = 'LOADING';

export const SUCCESS = 'SUCCESS';

export const ERROR = 'ERROR';

export const REQUEST = 'REQUEST';
